import React from "react";
import SideMenu, { SideMenuLink } from "@amzn/meridian/side-menu";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { setIsSideMenuOpen } from "src/store/layoutSlice";
import { useNavigate, useLocation } from "react-router-dom";

const LandingSideMenu = () => {
  const { isSideMenuOpen } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path: string) => {
    navigate(path);
    dispatch(setIsSideMenuOpen(false));
  };

  return (
    <SideMenu
      type="overlay"
      open={isSideMenuOpen}
      onClose={() => dispatch(setIsSideMenuOpen(false))}
    >
      <SideMenuLink
        selected={location.pathname === "/home"}
        onClick={() => handleNavigation("/home")}
      >
        Home
      </SideMenuLink>
      <SideMenuLink
        selected={location.pathname === "/templates"}
        onClick={() => handleNavigation("/templates")}
      >
        Templates
      </SideMenuLink>
      <SideMenuLink
        selected={location.pathname === "/completedInspections"}
        onClick={() => handleNavigation("/completedInspections")}
      >
        Completed Inspections
      </SideMenuLink>
    </SideMenu>
  );
};

export default LandingSideMenu;
